import { Text } from "@solomon-labs/design/components/ui";
import React from "react";

/**
 * @version 1.0.0
 * @published 2026-04-08
 * @history
 *   1.0.0 — Initial publish from prototype/pages/Stats/StatsPrototypePage.tsx.
 *           The "Stats" title + product selector (sUSDv / YaaS) + time period
 *           selector (7d / 30d / 90d / 1y / All time) row displayed above the
 *           Stats tab bar.
 */
export function StatsHeader(): React.ReactElement {
    return (
        <div className="flex items-baseline justify-between mb-4">
            <div className="flex items-baseline gap-6">
                <Text variant="h1" className="text-foreground-base">
                    Stats
                </Text>
            </div>
            {/* Hidden until product-specific stats are backed by real data. */}
            {/* <Tabs items={[{ label: "sUSDv", value: "sUSDv" }, { label: "YaaS", value: "yaas" }]} /> */}
            {/* Hidden until all tabs support live time-period filtering. */}
            {/* <Tabs items={[{ label: "7d", value: "7d" }, { label: "30d", value: "30d" }, { label: "90d", value: "90d" }, { label: "1y", value: "1y" }, { label: "All time", value: "all" }]} /> */}
        </div>
    );
}
